// src/translations/es.js

export const esTranslations = {
    // General / Common
    home: "Inicio",
    company: "Compañía",
    services: "Servicios",
    operations: "Operaciones",
    sustainability: "Sostenibilidad",
    contactUs: "Contáctanos",
    resources: "Recursos",
    information: "Información",
    followUsText: "Conoce más de nuestros productos y servicios ingresando a:",
    copyrightSlogan: "Servicios Energéticos y Ambientales",
    allRightsReserved: "Todos los derechos reservados.",
    selectLanguage: "Seleccionar Idioma",
    discoverMore: "Descubre Más",
    exploreOurServices: "Explora Nuestros Servicios",
    latestUpdates: "Últimas Actualizaciones",
    readMore: "Leer Más",
  
    // Header Specific (Can be nested if preferred, e.g., header.company)
    headerTitle: "Título del Encabezado", // Example if needed
  
    // Services Dropdown / Categories
    oilAndGas: "Petróleo y Gas",
    environmental: "Ambiental",
    consultoria: "Consultoría", // Kept separate as it was listed separately
    fluidosPerforacion: "Fluidos de Perforación",
    fluidosCompletamiento: "Fluidos de Completamiento",
    controlSolidos: "Control de Sólidos",
    productosQuimicos: "Productos Químicos",
    laboratorio: "Laboratorio de Análisis Ambiental", // More specific
    decarbonization: "Descarbonización",
    alquilerEquipos: "Alquiler de Equipos",
  
    // Footer Specific
    workWithUs: "Trabaja con Nosotros",
    termsConditions: "Términos y Condiciones",
    pqrs: "PQRS",
    policies: "Políticas",
    codeOfEthics: "Código de Ética",
    certifications: "Certificaciones",
    brochure: "Folleto", // Or Brochure if preferred as proper noun
  
    // Home Page Specific
    innovationInEnergy: "Innovación en Energía",
    sustainableEnvironmentalSolutions: "Soluciones Ambientales Sostenibles",
    advancedOilAndGasServices: "Servicios Avanzados de Petróleo y Gas",
    whoWeAre: "Quiénes Somos",
    whatWeDo: "Qué Hacemos",
    newTechnologies: "Nuevas Tecnologías de Electrificación",
    newTechnologiesDate: "4 de febrero de 2025",
    newTechnologiesDescription: "Baker Hughes lanza un trío de tecnologías de electrificación para operaciones en tierra y mar.",
    automatedProduction: "Solución Automatizada de Producción en Campo",
    automatedProductionDate: "3 de febrero de 2025",
    automatedProductionDescription: "Baker Hughes y NNPC/FIRST E&P JV implementarán la solución Leucipa™ de producción automatizada en el Delta del Níger.",
    whoWeAreDescription1: "Somos una empresa colombiana con experiencia en la prestación de servicios de Fluidos de Perforación, Fluidos de Completamiento, Control de Sólidos y Laboratorio de Análisis Ambiental acreditado por el IDEAM. Enfocados en el desarrollo de tecnología para toda la industria energética, estamos representados por un excelente equipo de trabajo, altamente calificado y con una importante trayectoria en el sector energético.",
    whoWeAreDescription2: "Grupo Sierra Alta es el representante de todos los sistemas de fluidos WEATHERFORD. Con estos, hemos participado en la perforación de más de 1400 pozos con diferentes operadoras tales como: Ecopetrol, SierraCol, Frontera, Hocol, Occidental, Mansarovar, Interoil, entre otras. Cumpliendo con elevados estándares de calidad, nos destacamos por ofrecer soluciones de ingeniería de la mejor calidad, adaptadas a las necesidades de nuestros clientes.",
    whatWeDoDescription1: "Desarrollamos e implementamos las tecnologías más avanzadas para servir a empresas energéticas e industriales que buscan soluciones más eficientes, confiables y limpias. Nuestra diversa cartera de tecnologías y soluciones está transformando la forma en que la industria funciona hoy y en el futuro.",
    whatWeDoDescription2: "Ofrecemos servicios especializados en Fluidos de Perforación, Fluidos de Completamiento, Control de Sólidos y Laboratorio de Análisis Ambiental. Además, somos líderes en la implementación de sistemas de fluidos WEATHERFORD, garantizando la máxima eficiencia y productivity en cada proyecto.",
  
    // Operations Page Specific
    operationsPageTitle: "Operaciones",
    oilAndGasTab: "OIL & GAS",
    ambientalTab: "AMBIENTAL",
  
     // Solid Control Page Specific
     solidControlCTATextStart: "¿Necesitas una solución efectiva para el",
     solidControlCTATextHighlight: "Control de Sólidos?",
  
    // Add keys for other pages as needed (Contact form labels, PQRS labels, etc.)
    // Example:
    // formFullName: "Nombre Completo",
    // formEmail: "Correo Electrónico",
    // formSubmit: "Enviar",
  };